import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";

// French-only Thank You page — content deliberately not internationalised.
export default function ThankYou() {
  return (
    <main className="min-h-[calc(100vh-64px)] py-20" style={{ backgroundColor: "var(--vx-bg)" }} data-testid="thank-you-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16" style={{ backgroundColor: "var(--vx-emerald-light)", color: "var(--vx-emerald)" }} data-testid="thank-icon">
          <CheckCircle2 size={36} />
        </div>
        <div className="vx-eyebrow mt-6">Confirmation</div>
        <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl font-bold" style={{ color: "var(--vx-navy)" }} data-testid="thank-title">
          Merci pour votre inscription
        </h1>
        <p className="mt-5 text-base sm:text-lg leading-relaxed" style={{ color: "var(--vx-graphite)" }} data-testid="thank-body">
          Votre demande a bien été prise en compte. Un e-mail de confirmation contenant votre premier
          rapport stratégique sur le lithium français vient de vous être envoyé.
        </p>
        <p className="mt-3 text-sm" style={{ color: "var(--vx-graphite-light)" }}>
          Si vous ne recevez rien sous quelques minutes, pensez à vérifier votre dossier « courrier indésirable ».
        </p>
        <div className="mt-8">
          <Link to="/" className="vx-btn-primary" data-testid="thank-back-home">
            <ArrowLeft size={16} /> Retour à l'accueil
          </Link>
        </div>
      </div>
    </main>
  );
}
